import { useState, memo } from "react";
import Button from "../../Elements/Button/Button.js";
import parse from "html-react-parser";
import SuspendedUserModal from "components/Reusable/Modals/SuspendedUserModal.tsx";
import Form from "components/Reusable/Form/Form.js";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { EMAIL_VALIDATOR } from "helpers/validators.js";
import { RecoverPasswordUserRequestReactApiRequest } from "../../../api/UsersController.ts";

import "../JumboCodesRecovery/JumboCodesRecovery.scss";
import "./PasswordRecover.scss";

const Success = memo(({ setSuccess }) => {
  const { getTextByKey, getPath } = useContent();
  const link = getPath() + "password-recover";
  const successTextKey = getTextByKey(
    "recover-password-success-description"
  ).replace("%link%", link);

  const handleClick = (e) => {
    e.preventDefault();

    if (e.target.tagName === "A") {
      setSuccess(false);
    }
  };

  return (
    <>
      <p onClick={handleClick}>{parse(successTextKey)}</p>
      <LinkToNewTab page={"home"}>
        <Button>{getTextByKey("go-home-button")}</Button>
      </LinkToNewTab>
    </>
  );
});

const PasswordRecover = () => {
  const { getTextByKey, getLanguageCulture, getBasicSettingsData } =
    useContent();
  const [success, setSuccess] = useState(false);
  const { addToast } = useToasts();
  const { setModal } = useModal();

  const globalCaptchaType = getBasicSettingsData()?.recaptchaType;

  const showError = (errMessage) => {
    addToast(getTextByKey(errMessage || "reset-password-general-error"), {
      appearance: "error",
    });
    setSuccess(false);
  };

  const sendMailToReset = async (body) => {
    const parameters = {
      userEmail: body.RecoverPass,
      didRecaptcha: true,
      culture: getLanguageCulture(),
      recaptchaResponse: body.recaptchaResponse,
      captchaServiceName: "google", // replace to cloudflare,
    };
    const response = await RecoverPasswordUserRequestReactApiRequest(
      parameters
    );

    if (response.status === "success") {
      setSuccess(!!response.data);
      if (!response.data) {
        showError("user-not-exist");
      }
    } else {
      const errMessage = response?.data;
      if (errMessage === "Error #4200") {
        setModal({
          modal: SuspendedUserModal,
        });
      } else {
        showError();
      }
    }
  };

  const isCustomDomain = checkCurrDomainIsOrgDomain();

  return (
    <div className={`full-page ${isCustomDomain ? "" : "recover-full-page"}`}>
      <div className="page-container recover-password">
        <div className="title-page">
          <h1>{getTextByKey("recover-password-title")}</h1>
          <div className="title-divider"></div>
        </div>
        <div className="main-page">
          {!success ? (
            <>
              <p>{getTextByKey("recover-password-text")}</p>
              <Form
                fields={{
                  RecoverPass: {
                    fieldKey: "RecoverPass",
                    element: "input",
                    type: "email",
                    title: "RecoverPass",
                    placeholder: "reset-password-email",
                    validation: {
                      required: true,
                      invalidMessage: "invalid-email-text",
                      reg: EMAIL_VALIDATOR,
                    },
                  },
                }}
                fieldsProps={{ label: "hidden" }}
                onSubmit={sendMailToReset}
                submitProps={{
                  title: getTextByKey("reset-password-button"),
                }}
                // captchaProvider="cloudflare"
                // cloudflareActionName="recoverPassword"
              />
            </>
          ) : (
            <Success setSuccess={setSuccess} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordRecover;
